<template>
  <div class="employment">
    <div class="container">
      <div class="sharing_title">
        <img
          src="../../img/Employment_Sharing.svg"
          alt=""
        />
        <h3 :style="{ fontSize: fontSize.h3 + 'em' }">海外就業分享</h3>
      </div>
      <Tab />
    </div>
  </div>
</template>
<script>
//  無障礙文字子層引入設定
import Tab from "../Tab.vue";
import { defineComponent, ref, inject } from "vue";

export default defineComponent({
  name: "Employment",
  components: {
    Tab,
  },
  setup() {
    //  無障礙文字子層引入設定
    let fontSize = inject("fontSize");
    return {
      activeKey: ref("1"),
      fontSize,
    };
  },
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.sharing_title {
  img {
    width: 6%;
  }
}
.employment {
  .container {
    @include sec_width();
  }
}
</style>
